import React, { Component } from "react";
import { Modal, Icon } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import _ from "i18n";

class FilterModal extends Component {
  handleDontSaveClick = () => {
    this.props.handleDontSaveClick();
  };

  handleSaveClick = () => {
    this.props.handleSaveClick();
  };

  handleCancelClick = () => {
    this.props.handleCancelClick();
  };

  render() {
    const { visible, budgetManagement } = this.props;

    return (
      <Modal
        visible={visible}
        title={null}
        closable={false}
        footer={null}
      >
        <div className={'px-3 py-3'}>
          <div className={'flex items-start'}>
            <ExclamationCircleOutlined className={'flex mr-2'} style={{
              color: '#FFD700',
              fontSize: '20px'
            }}/>
            {_('CHANGE_FILTER_WITHOUT_SAVING')}
          </div>
          <div className={'flex justify-around '}>
            <button key="back" className={'cancel'}
                    onClick={this.handleCancelClick}>
              {_('cancel')}
            </button>
            <button key="quit" className={'notSave'}
                    onClick={this.handleDontSaveClick}>
              {_('QUIT')}
            </button>
            <button key="submit" className={'save'}
                    onClick={this.handleSaveClick}>
              {_('save')}
              {budgetManagement.generateFollowUp.processing === true &&
              <Icon className="ml-2" type="sync" spin/>}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default FilterModal;



// WEBPACK FOOTER //
// ./app/components/common/BudgetManagement/FilterModal.js